import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { OdometerLogTrailModel } from './odometerlogtrail.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class OdometerLogTrailService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetOdometerLogTrail(input?: DataListModel, onlyRequiredDescription?: boolean): Observable<IAPIResponse> {
    let getOdometerLogTrailUrl = WeGoConfig.API_GET_ODOMETERLOGTRAIL_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getOdometerLogTrailUrl = getOdometerLogTrailUrl + "?" + queryString + "&onlyRequiredDescription=" + onlyRequiredDescription;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getOdometerLogTrailUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleDropdownForOdometer(permissionType : string): Observable<IAPIResponse> {
    let getOdometerLogTrailUrl = WeGoConfig.API_GET_ODOMETER_VEHICLE_DROPDOWN_LIST + '?permissionType='+permissionType;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getOdometerLogTrailUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportOdometerLogTrailList(input?: DataListModel, onlyRequiredDescription?: boolean): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_ODOMETER_LIST + "?" + queryString + "&onlyRequiredDescription=" + onlyRequiredDescription;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  public GetOdometerLogTrailByHashId(odometerLogTrailHashId: string): Observable<IAPIResponse> {
    let getCompnayUrl = WeGoConfig.API_GET_ODOMETERLOGTRAIL_BY_HASH + "?odometerLogTrailHashId=" + odometerLogTrailHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getCompnayUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddOdometerLogTrail(odometerLogTrailModel: OdometerLogTrailModel): Observable<IAPIResponse> {
    let body = odometerLogTrailModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_ODOMETERLOGTRAIL_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


  public UpdateDescriptionOfDeviation(odometerLogTrailModel: OdometerLogTrailModel) {
    let body = odometerLogTrailModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_ODOMETER_DESCRIPTION, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/odometerlogtrail/models/odometerlogtrail.service.ts